import { render, staticRenderFns } from "./RadioCheckedUI.vue?vue&type=template&id=c63760d6&scoped=true&lang=pug"
import script from "./RadioCheckedUI.vue?vue&type=script&lang=js"
export * from "./RadioCheckedUI.vue?vue&type=script&lang=js"
import style0 from "./RadioCheckedUI.vue?vue&type=style&index=0&id=c63760d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63760d6",
  null
  
)

export default component.exports